/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExportedCredential } from './ExportedCredential';
import {
    ExportedCredentialFromJSON,
    ExportedCredentialFromJSONTyped,
    ExportedCredentialToJSON,
} from './ExportedCredential';
import type { OrganizationDetails } from './OrganizationDetails';
import {
    OrganizationDetailsFromJSON,
    OrganizationDetailsFromJSONTyped,
    OrganizationDetailsToJSON,
} from './OrganizationDetails';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';
import type { PersonRet } from './PersonRet';
import {
    PersonRetFromJSON,
    PersonRetFromJSONTyped,
    PersonRetToJSON,
} from './PersonRet';

/**
 * 
 * @export
 * @interface GetMeResp
 */
export interface GetMeResp {
    /**
     * 
     * @type {PersonRet}
     * @memberof GetMeResp
     */
    person: PersonRet;
    /**
     * 
     * @type {Array<OrganizationDetails>}
     * @memberof GetMeResp
     */
    organizations: Array<OrganizationDetails>;
    /**
     * 
     * @type {Array<PersonHandle>}
     * @memberof GetMeResp
     */
    handles: Array<PersonHandle>;
    /**
     * 
     * @type {Array<ExportedCredential>}
     * @memberof GetMeResp
     */
    credentials: Array<ExportedCredential>;
}

/**
 * Check if a given object implements the GetMeResp interface.
 */
export function instanceOfGetMeResp(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "person" in value;
    isInstance = isInstance && "organizations" in value;
    isInstance = isInstance && "handles" in value;
    isInstance = isInstance && "credentials" in value;

    return isInstance;
}

export function GetMeRespFromJSON(json: any): GetMeResp {
    return GetMeRespFromJSONTyped(json, false);
}

export function GetMeRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person': PersonRetFromJSON(json['person']),
        'organizations': ((json['organizations'] as Array<any>).map(OrganizationDetailsFromJSON)),
        'handles': ((json['handles'] as Array<any>).map(PersonHandleFromJSON)),
        'credentials': ((json['credentials'] as Array<any>).map(ExportedCredentialFromJSON)),
    };
}

export function GetMeRespToJSON(value?: GetMeResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person': PersonRetToJSON(value.person),
        'organizations': ((value.organizations as Array<any>).map(OrganizationDetailsToJSON)),
        'handles': ((value.handles as Array<any>).map(PersonHandleToJSON)),
        'credentials': ((value.credentials as Array<any>).map(ExportedCredentialToJSON)),
    };
}

